import './PublicPage.scss';

import AnimatedContainer from 'components/AnimatedContainer/AnimatedContainer';
import LanguageSwitcher from 'components/Header/LanguageSwitcher';
import Helmet from 'components/Helmet/Helmet';
import type { PropsWithChildren } from 'react';
import React from 'react';

interface Props {
  title: string;
  className?: string;
}

const PublicPage: React.FC<PropsWithChildren<Props>> = (props): React.ReactElement => {
  return (
    <div className={`PublicPage ${props.className}`}>
      <Helmet title={props.title} />
      {/* TODO: solve how to handle language on public pages */}
      <div className="PublicPage_language-switcher">
        <LanguageSwitcher />
      </div>
      <div className="PublicPage_content">
        <AnimatedContainer>{props.children}</AnimatedContainer>
      </div>
    </div>
  );
};

export default PublicPage;
